import { normalizeForTypedAnswer } from "./frenchOrthography";

export function normalizeRecallWord(value) {
  return normalizeForTypedAnswer(value);
}

export function evaluateRecallEntries(expectedWords, entries) {
  const remaining = expectedWords.map((word) => normalizeRecallWord(word));

  return entries.map((entry) => {
    const normalizedEntry = normalizeRecallWord(entry);
    if (!normalizedEntry) return "missing";

    const matchIndex = remaining.findIndex((word) => word === normalizedEntry);
    if (matchIndex >= 0) {
      remaining[matchIndex] = null;
      return "correct";
    }

    return "wrong";
  });
}

export function countRecallResults(results) {
  return results.reduce(
    (counts, status) => {
      if (status === "correct") counts.correct += 1;
      else counts.incorrect += 1;
      return counts;
    },
    { correct: 0, incorrect: 0 }
  );
}

export function getRecallEncouragement(correct, total) {
  const safeTotal = Math.max(1, Number(total) || 1);
  const safeCorrect = Math.max(0, Number(correct) || 0);
  const ratio = safeCorrect / safeTotal;

  if (ratio >= 0.93) {
    return {
      tier: "excellent",
      title: "Impressionnant !",
      detail: `${safeCorrect}/${safeTotal} mots restitués.`,
    };
  }
  if (ratio >= 0.73) {
    return {
      tier: "good",
      title: "Plutôt bien !",
      detail: `${safeCorrect}/${safeTotal} — bel effort de mémoire.`,
    };
  }
  if (ratio >= 0.53) {
    return {
      tier: "fair",
      title: "Pas si mal.",
      detail: `${safeCorrect}/${safeTotal} mots retrouvés.`,
    };
  }
  if (ratio >= 0.33) {
    return {
      tier: "encouraging",
      title: "Encourageant.",
      detail: `${safeCorrect}/${safeTotal} — chaque mot compte.`,
    };
  }
  return {
    tier: "low",
    title: "Tu peux mieux faire.",
    detail: `${safeCorrect}/${safeTotal} mots restitués.`,
  };
}
